module.exports = __webpack_public_path__ + "img/logo-sg-flag.fbfbe2ba.png";